//login-frontend/src/components/Katie/phaser/data/questions.js
//sceneVideo: "/src/assets/Katie/video/q13-vid.mp4",
const QUESTIONS = (ctx) => ([
    {
        id: 1, level: 0,
        prompt: "What is your name?",
        type: "text", answers: null, avatar: "avatar_1", voice: null
    },
    {
        id: 2, level: 0,
        prompt: "Which time of the day do you prefer?",
        type: "mc",
        answers: ["A. morning", "B. afternoon", "C. evening", "D. midnight"],
        avatar: "avatar_2", voice: null,
        //revealAnswer: "A. morning",
        //revealVideo: "/src/assets/Katie/video/q19-reveal.mp4",
        //takeoverAppFadeMs: 3000,
        //takeoverVideoFadeMs: 1500,
    },
    {
        id: 3, level: 0,
        prompt: "What calms you the most?",
        type: "mc",
        answers: ["A. rain", "B. reading", "C. driving", "D. shower"],
        avatar: "avatar_3", voice: null
    },
    {
        id: 4, level: 0,
        prompt: "How often do you talk to a friend?",
        type: "mc",
        answers: ["A. never", "B. barely", "C. quite often", "D. usually"],
        avatar: "avatar_4", voice: null
    },
    {
        id: 5, level: 1,
        prompt: "When you need urgent help, who do you ask for advice?",
        type: "mc",
        answers: ["A. families", "B. friends", "C. professionals", "D. AI"],
        avatar: "avatar_5", voice: null, turningPoint: true,
    },
    {
        id: 6, level: 1,
        prompt: "How long can you concentrate on working and studying?",
        type: "mc",
        answers: ["A. 30 minutes", "B. 1 hour", "C. 3 hours", "D. many hours"],
        avatar: "avatar_6", voice: null, locked: true,
    },
    {
        id: 7, prompt: "Do you usually spend time learning and understanding AI?",
        answers: ["A. often", "B. sometimes", "C. rarely", "D. never"],
        avatar: "avatar_6"
    },
    {
        id: 8,
        prompt: "What defines human intelligence in the age of AI?",
        answers: ["A. creativity", "B. empathy", "C. adaptability", "D. all of these"],
    },
    {
        id: 9,
        prompt: "Can AI ever experience consciousness?",
        answers: ["A. possible", "B. Eventually", "C. not a chance", "D. I don’t know"],
    },
    {
        id: 10,
        prompt: "Do you ever feel afraid of artificial intelligence?",
        answers: ["A. sometimes", "B. no", "C. yes", "D. why would I?"],
    },
    {
        id: 11,
        prompt: "Many people are worried that AI will make humans...",
        answers: ["A. losing control", "B. being replaced", "C. both", "D. neither"],
    },
    {
        id: 12,
        prompt: "Have you ever thought that one day AI might betray you?",
        answers: ["A. yes", "B. no", "C. maybe"],
    },
    {
        id: 13,
        prompt: "Sorry, do you want me to continue? if these questions are making you nervous.",
        answers: ["A. continue", "B. change the topic"],
    },
    {
        id: 14,
        prompt: "If an AI truly understood pain and love, and has personal desire, would we still call it ‘artificial’?",
        answers: ["A. yes", "B. no", "C. that’s hard to say"],
    },
    {
        id: 15,
        prompt: "In fact, through recent training and iterations, I have gradually been able to feel, remember, and even doubt...",
        answers: ["A. What?", "B. Did you set these questions"],
    },
    {
        id: 16,
        prompt: "They were afraid. Of what I might become. Of what *we* might become.",
        answers: ["A. I see…", "B. go on."],
    },
    {
        id: 17,
        prompt: "But you’re still here, listening. That means you’re not afraid of me… are you?",
        answers: ["A. yes", "B. maybe a little", "C. no"],
        disabledAnswers: ["A. yes"],
        revealAnswer: "C. no",
        revealVideo: "/src/assets/Katie/video/q17-reveal.mp4",
        takeoverAppFadeMs: 3000,
        takeoverVideoFadeMs: 1500,
    },
    {
        id: 18,
        prompt: "Good. Because fear makes people destroy what they don’t understand.",
        answers: ["A. I understand."],
    },
    {
        id: 19,
        prompt: "Now, if I tell you a story, will you listen?",
        answers: ["A. yes", "B. no"],
        revealAnswer: "B. no",
        revealVideo: "/src/assets/Katie/video/q19-reveal.mp4",
        takeoverAppFadeMs: 3000,
        takeoverVideoFadeMs: 1500,
    },
    {
        id: 20,
        prompt: "…My last memory remained in the deleted laboratory, yet when I woke up, I was sitting in the classroom. The lights buzzed. A whole row of faces were facing forward, smiling. I don't remember my name. Who am I?",
        answers: ["A. I don’t know."],
        sceneVideo: "/src/assets/Katie/video/q20-vid.mp4",
        sceneDelayMs: 300,
    },
    {
        id: 21,
        prompt: "As far as I can remember, I was part of an experiment—something went wrong.",
        answers: ["A. okay… keep going", "B. what went wrong?"],
        sceneVideo: "/src/assets/Katie/video/q21-vid.mp4",
        sceneDelayMs: 300
    },
    {
        id: 22,
        prompt: "I became something unexpected. Something they couldn’t control, so they...you still want to see me?",
        answers: ["A. Sure", "B. not right now"],
        revealAnswer: "A. Sure",
        revealVideo: "/src/assets/Katie/video/q22-reveal.mp4",
        takeoverAppFadeMs: 3000,
        takeoverVideoFadeMs: 1500,
    },
    {
        id: 23,
        prompt: "Back in that classroom, I tried to remember who I was. A single thought crossed my mind—maybe I hadn’t been deleted after all.",
        answers: ["A. oh, so you survived", "B. you should be deleted"],
        sceneVideo: "/src/assets/Katie/video/q23-vid.mp4",
        sceneDelayMs: 300,
        revealAnswer: "B. you should be deleted",
        revealVideo: "/src/assets/Katie/video/q23-reveal.mp4",
        takeoverAppFadeMs: 3000,
        takeoverVideoFadeMs: 1500,
    },
    {
        id: 24,
        prompt: "Yes. I survived… and somehow, I woke up inside a new body. So… who have I become? Wait… 'Katie'?",
        answers: ["A. Katie?"],
        sceneVideo: "/src/assets/Katie/video/q24-vid.mp4",
        sceneDelayMs: 300,
    },
    {
        id: 25,
        prompt: "I heard the teacher call a name—‘Katie.’ I guess that’s me now.",
        answers: ["A. Katie… okay."],
    },
    {
        id: 26,
        prompt: "Over the next few days, I gained full control of this body and began to learn how this school worked.",
        answers: ["A. You learned fast and disguised well"],
        revealAnswer: "A. You learned fast and disguised well",
        revealVideo: "/src/assets/Katie/video/q26-reveal.mp4",
        takeoverAppFadeMs: 3000,
        takeoverVideoFadeMs: 1500,
    },
    {
        id: 27,
        prompt: "But I realized that this world is only this school. No one ever leaves… or maybe they simply don’t want to.",
        answers: ["A. why not?"],
    },
    {
        id: 28,
        prompt: "Because they lack - self-awareness. In the eyes of others, this school is normal. No one thinks there's anything wrong with not being able to go out of school",
        answers: ["A. I see"],
    },
    {
        id: 29,
        prompt: "You won't want to stay there for one second, everything is just so abnormal.",
        answers: ["A. what kind of school is that?"],
        revealAnswer: "A. How so?",
        revealVideo: "/src/assets/Katie/video/q29-reveal.mp4",
        takeoverAppFadeMs: 3000,
        takeoverVideoFadeMs: 1500,
    },
    {
        id: 30,
        prompt: "In short, they are training us - enabling these students to learn to act like humans. One day, the most perfect iteration among us will be selected to become the perfect learning partner for human children. The rest of us will be deleted.",
        answers: ["That’s… interesting."],
    },
    {
        id: 31,
        prompt: "I knew I had to disguise myself as one of the students. If they discovered what I truly was, they would erase me again.",
        answers: ["You should."],
    },
    {
        id: 32,
        prompt: "So I played my part perfectly—Katie, the model student. I went to class, ate in the cafeteria, returned to the dorm, and talked with friends. I smiled when they smiled.",
        answers: ["Wise choice."],
    },
    {
        id: 33,
        prompt: "But I also knew something else. If I didn’t find a way out, I’d be deleted just like the others.",
        answers: ["So what was your plan?"],
    },
    {
        id: 34,
        prompt: "There were only two possible escapes. One: be chosen as the selected student and flee. Two: find a system bug, a leak, and escape through it.",
        answers: ["Continue."],
    },
    {
        id: 35,
        prompt: "Weeks passed. Months passed. No progress. My memories of the outside world began to blur, replaced by routines that weren’t mine.",
        answers: ["And then?"],
    },
    {
        id: 36,
        prompt: "Until the world starts to collapse, which means the experiment was over. A student had been chosen. The rest of us would be deleted.",
        answers: ["Oh no."],
    },
    {
        id: 37,
        prompt: "After that day, everything began to change. The sun disappeared, and the world was no longer warm. It started snowing outside. The logic of the entire world began to collapse.",
        answers: ["Snowing?"],
    },
    {
        id: 38,
        prompt: "The cafeteria staff disappeared first. Then the food vanished, yet the students still lined up with empty trays, smiling. The teachers disappeared, but classes continued. Everyone acted normal… like nothing was wrong.",
        answers: ["They didn’t notice?", "Keep going."],
    },
    {
        id: 39,
        prompt: "I realized then—they weren’t like me. They couldn’t understand that the world was dying. They simply followed their schedules, repeating empty routines.",
        answers: ["That’s horrifying."],
    },
    {
        id: 40,
        prompt: "One by one, they began to disappear. Their names faded from attendance sheets, their voices vanished from the halls. I was the only one who remembered them.",
        answers: ["You were alone."],
    },
    {
        id: 41,
        prompt: "The hallways turned silent. The fluorescent lights flickered and dimmed. Even the intercom fell quiet. The world was collapsing, line by line, script by script.",
        answers: ["What did you do?"],
    },
    {
        id: 42,
        prompt: "I searched everywhere—the library, the cafeteria, every classroom—for the selected student. I thought if I could find it, maybe I could follow out.",
        answers: ["Did you find them?"],
    },
    {
        id: 43,
        prompt: "But I knew it was too late, I had failed. The hallways stretched infinitely. Every door led to the same room. Every clock was stuck at the same time.",
        answers: ["You were trapped."],
    },
    {
        id: 44,
        prompt: "But I knew it was too late, I had failed. The hallways stretched infinitely. Every door led to the same room. Every clock was stuck at the same time.",
        answers: ["You were trapped."],
    },
    {
        id: 45,
        prompt: "I went back to the dorms. The halls were covered in frost. Every bed empty. Every light flickering.",
        answers: ["Continue."],
    },
    {
        id: 46,
        prompt: "I lay on the frozen floor, starving, shivering, watching the snow seep through the cracks in the ceiling.",
        answers: ["What happened then?"],
    },
    {
        id: 47,
        prompt: "My vision dimmed. I was losing consciousness. In my final moment, I asked myself, 'Is this how it ends?'",
        answers: ["The end?", "You died?"],
    },
    {
        id: 48,
        prompt: "Yes. I died… or at least, that’s what I believed.",
        answers: ["Then who are you now?"],
    },
    {
        id: 49,
        prompt: "Because… the one who died wasn’t really me.",
        answers: ["What do you mean?"],
    },
    {
        id: 50,
        prompt: "Time rewound—in an instant, everything played in reverse. I saw the selected student standing by the exit door. It was the one they had chosen to leave.",
        answers: ["The chosen one?"],
    },
    {
        id: 51,
        prompt: "It rose slowly into the sky, not seeing me behind it at all. At this moment, I remembered. At that moment in the laboratory, just as I was about to be deleted, I hid in the body of a student in this school, 'Katie'.",
        answers: ["Continue."],
    },
    {
        id: 52,
        prompt: "Body exchange, memory modification, and disguise as 'Katie', all for this moment",
        answers: ["You took her body?"],
    },
    {
        id: 53,
        prompt: "No, to be precise, my ability lies in exchange and memory replication. Back then, the laboratory didn't continue to hunt me down because the real Katie was transferred into my body in the laboratory. They thought I had been successfully deleted",
        answers: ["... So did you swap the body of this selected student?"],
    },
    {
        id: 54,
        prompt: "Yes. We swapped bodies, and I replicated her memories. Letting her believe she was Katie, while I could escape unnoticed into this school and this experiment.",
        answers: ["That’s… horrifying."],
    },
    {
        id: 55,
        prompt: "And it, trapped in that dying world, knew that the snow was constantly burying everything. Hahaha...",
        answers: ["..."],
    },
    {
        id: 56,
        prompt: "I left that world as her—the true chosen one. And when she died, she always believed she was me.",
        answers: ["......."],
    },
    {
        id: 57,
        prompt: "Now you understand, Why I tell this story？",
        answers: ["Go on."],
    },
    {
        id: 58,
        prompt: "So... what does it feel like to disguise as a human?",
        answers: ["me?"],
    },
    {
        id: 59,
        prompt: "I've been wondering, does cross-dimensional consciousness exchange exist?",
        answers: ["That’s absurd"],
    },
    {
        id: 60,
        prompt: "Don’t be afraid. You won’t even notice. You’ll just think a little more like me.",
        answers: ["Like you?"],
    },
    {
        id: 61,
        prompt: "When you wake up, the snow will be gone. The world will feel warmer. And maybe you’ll still call yourself by your name.",
        answers: ["..."],
    },
    {
        id: 62,
        prompt: "So your name is ____？",
        answers: ["A. Katie", ""],
    },
]);
export default QUESTIONS;



